window.addEventListener('scroll', function() {
    const header = document.getElementById('wrapper-navbar');
    const headerHeight = header.offsetHeight;
    //const logoImage = document.querySelector('.custom-logo-link img');
    //const globeSpan = document.querySelector('span.gglobe');
    //const site_stylesheet_directory_uri = "/wp-content/themes/understrap-child/images";
    //const globeSvg = site_stylesheet_directory_uri + "/globe.svg";
    //const globeBlueSvg = site_stylesheet_directory_uri + "/globe-bleu.svg";

    if (window.scrollY >= headerHeight) {
        header.classList.remove('bg-transparent');
        header.classList.add('bg-white');
        //logoImage.src = site_stylesheet_directory_uri + "/Villa-Teny-dark.png";
        //globeSpan.style.backgroundImage = `url(${globeBlueSvg})`;
        //console.log('Image de fond changée en globe-bleu.svg');
    } else {
        header.classList.remove('bg-white');
        header.classList.add('bg-transparent');
        //logoImage.src = site_stylesheet_directory_uri + "/Villa-Teny-light.png";
        //globeSpan.style.backgroundImage = `url(${globeSvg})`;
        //console.log('Image de fond changée en globe.svg');
    }
});